import { render, staticRenderFns } from "./NotificationBox.vue?vue&type=template&id=dc876468"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"
import style0 from "./NotificationBox.vue?vue&type=style&index=0&id=dc876468&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc876468')) {
      api.createRecord('dc876468', component.options)
    } else {
      api.reload('dc876468', component.options)
    }
    module.hot.accept("./NotificationBox.vue?vue&type=template&id=dc876468", function () {
      api.rerender('dc876468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification/NotificationBox.vue"
export default component.exports